export default __webpack_public_path__ + "static/media/unattempt-icon.0eafab99.svg";